import React from 'react';
import "../../css/components/ImageLoader.css";
import HmAjax from '../../util/HmAjax';
import NativeAjax from '../../util/NativeAjax';
import LoggedInPage from '../../views/core/LoggedInPage';
import $ from 'jquery';

class ImageUpload extends LoggedInPage {
  constructor(props) {
    super(props);
    this.state = {
      file: '',
      imagePreviewUrl: '',
      imageLoaded: false
    };
    this._handleImageChange = this._handleImageChange.bind(this);
    this._handleSubmit = this._handleSubmit.bind(this);
    this.prevFn=this.prevFn.bind(this);
    this.deleteImage = this.deleteImage.bind(this);

    this.callback = this.props.callback || function(imageUrl){}; 
    this.maxPictureSizeInKb = 200;
    this.maxFileNameLength = 0;
    this.picExtensions = ["jpeg","jpg","png"];
    this.unsupportedCharacters = "?!#$%&<>~:;'^\"\\/";   

    this.profilePicReqStatus = false;
  }

  isSizeValid(fileSizeinBytes){
    if(fileSizeinBytes && this.maxPictureSizeInKb){
      var fileSizeinKb = Math.round(fileSizeinBytes / 1000);
      return (fileSizeinKb <= this.maxPictureSizeInKb);
    }
    console.warn("maxFileSizeInKb not configured.");
    return false;
  }

  isFileTypeValid(filename){
    if(filename && this.picExtensions){
      for(var i=0; i < this.picExtensions.length; i++){
        if(filename.endsWith("."+this.picExtensions[i].toLowerCase()) || filename.endsWith("."+this.picExtensions[i].toUpperCase())){
          return true;
        }
      }
    }

    return false;
  }

  isFileNameLengthValid(filename){
    if(!this.maxFileNameLength){
     return true;
   }else if(filename){
     filename = filename.substr(0, filename.lastIndexOf("."));
     return (filename.length <= this.maxFileNameLength);
   }

   return false;
 }
 
 isFileNameValid(filename){
  if(filename && this.unsupportedCharacters){
   return !filename.match("[" + this.unsupportedCharacters + "]+");
 }
 
 return false;
}

componentDidMount(){
  //super.componentDidMount();
 this.setCurrentImage();

 if (typeof document !== 'undefined') {
  document.addEventListener('dragover', event => {
        // prevent default to allow drop
        event.preventDefault();
      }, false);
  document.addEventListener('drop', event => {
        // prevent default to allow drop
        event.preventDefault();
      }, false);
}
}

setCurrentImage(){
  var me = this;
  var success = function(response){
    if(response && response.imgUrl){
      me.setState({imagePreviewUrl:response.imgUrl, imageLoaded:true});
      me.callback.apply(this,[me.state.imagePreviewUrl]);
    }
  } 

  var failure = function(err){
    me.profilePicReqStatus= false;
    //Nothing as of now
  }

  if(!me.profilePicReqStatus){
    me.profilePicReqStatus = true;
    new HmAjax(this.getUrlFor("PROFILE_PIC")).get(success, failure);
  }
}

uploadImage(imageFile, elem) {
  var me = this;
  var success = function(response){
    if(response && response.imgUrl){
      me.setState({imagePreviewUrl:response.imgUrl, imageLoaded:true});
      me.callback.apply(this,[me.state.imagePreviewUrl]);
    }else if(response && response.status && response.status === "error"){
      me.showAlert(me.rb("system_error"),me.rb("pic.err.generic"));
      return;
    }
  } 

  var failure = function(err){

  }

  if(imageFile){
   // console.log("imageFile :::", imageFile);
   var uploadValid = true;
   var errLabel = "";
   var errMsg = "";

   if(imageFile.name && !me.isFileNameLengthValid(imageFile.name)){
    uploadValid = false;
    errLabel = me.rb("pic.label.file_name_length_invalid");
    errMsg = me.rb("pic.msg.file_name_length_invalid").replace("{1}",me.maxFileNameLength);
  }else if(imageFile.name && !me.isFileNameValid(imageFile.name)){
    uploadValid = false;
    errLabel = me.rb("pic.label.file_name_invalid");
    errMsg = me.rb("pic.msg.file_name_invalid").replace("{1}",me.unsupportedCharacters.split("").join(" "));
  }else if(imageFile.name && !me.isFileTypeValid(imageFile.name)){
    uploadValid = false;
    errLabel = me.rb("pic.label.file_format_invalid");
    errMsg = me.rb("pic.msg.file_format_invalid").replace("{1}",me.picExtensions.join("/"));
  }else if(imageFile.size && !me.isSizeValid(imageFile.size)){
    uploadValid = false;
    errLabel = me.rb("pic.label.file_size_exceed");
    errMsg = me.rb("pic.msg.file_size_exceed").replace("{1}",me.maxPictureSizeInKb);
  }


  if(!uploadValid){
    me.showAlert(errLabel,errMsg);
        //Clear the element for retries
        if(elem){
          elem.value = null;
        }
        me.setState({file: ' '});
        return ;
      }
      var myObj = {
        "file":imageFile
      }

      new NativeAjax(this.getUrlFor("PROFILE_PIC")).enableCORS().setFormData(myObj).post(success, failure);
    }
  }

  //Yet to implemented
  deleteImage(){
    var me = this;
    var success = function(resp){
      me.setState({imagePreviewUrl:'', imageLoaded:false});
      me.callback.apply(this,['']);
    }

    var failure = function(err){

    }

    var buttons = [{
      label:me.rb("btn.yes.delete_pic"),
      handler: () =>{ 
        new HmAjax(me.getUrlFor("PROFILE_PIC")).delete(success, failure);
      }
    },{
      label:me.rb("btn.no.delete_pic")
    }];

    me.showAlert(me.rb("alert.label.delete_pic"),me.rb("alert.msg.delete_pic"),buttons);


  }

  prevFn(e){
    $("#brwicon").trigger("click");

  }

  _handleSubmit(e) {

    e.preventDefault();
  //alert("upload");
  this.uploadImage(this.state.file)
    // TODO: do something with -> this.state.file
  }

  _handleImageChange(e) {
    var me = this;
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];

    //clear older image if available
    e.target.value = null;

    reader.onloadend = () => {
      this.setState({
        file: file,
        imagePreviewUrl: reader.result
      });
    }
    
    if(file==="undefined" || file===undefined){
      //alert("no file chosen");

    }else{
      me.uploadImage(file, e.target);
      
    }
  }

  renderUploadUI(){
    let {imagePreviewUrl} = this.state;
    let $imagePreview = null;
    if (imagePreviewUrl) {
      $imagePreview = (<img src={imagePreviewUrl} />);
    }

    return (
      <div id="imageupload">

      <form onSubmit={this._handleSubmit}>    
      <input type="file" id="brwicon" accept="image/*" onChange={this._handleImageChange} ref="test_input"/>
      </form>
      <div id="imgpreview" onClick={this.prevFn}>
      {$imagePreview}


      </div>
      <i className="material-icons photo" onClick={this.prevFn} >add_a_photo</i>
      {(() => { 
        if(this.state.imageLoaded){
          return (<i className="material-icons image-delete" onClick={this.deleteImage}>delete</i>);
        }
      })()}
      </div>
      )
  }

  render() {
    return this.renderUploadUI()
  }

}

export default ImageUpload;


// WEBPACK FOOTER //
// ./src/components/imageLoader/ImageUpload.js